export default "__VITE_ASSET__SOIWXiCq__"